import React from 'react';
import './AboutMe.css';
import './defaults.css';

const { Component } = React
class SplitText extends Component {
  render(){
    return(
      <span aria-label={this.props.copy} role={this.props.role}>
          {this.props.copy.split("").map(function(char, index){
            let style = {"animation-delay": (0.02 + index / 30) + "s"}
            return <span
              aria-hidden="true"
              key={index}
              style={style}>
              {char}
            </span>;
          })}
        </span>
    );
  }
}

const AboutMe = () => {
    return ( 
      <div class = 'body'>
        <div class='text'>
            <h1 class='name'><SplitText copy="Hi, My name is John! " role="heading" /></h1>
            <h2 class = 'intro'><SplitText copy="I'm a Software Developer that loves making resources for university, hosting club events with friends, and playing badminton" role="heading" /></h2>
            <h2 class = 'intro'><SplitText copy="If you catch me outside, feel free to say hi and we can chat a bunch!" /></h2>
          </div>
          <div class = 'inner'>
            <div id = 'image'>
              <img class="pfp" src="Good one.jpg" alt="Me" width="280" height="350"></img>
            </div>
          </div>
        </div> 
     );
}
 
export default AboutMe;